module.exports = __webpack_public_path__ + "static/photoLuc-f3d33b2e4485480c34db2315e950b482.png";